<div (click)="crossPressed.emit(null)" class="p-col-1 cross">X</div>
